<div class="section plant-capacities">
  <div class="clearfix">
    <h4 class="float-start">{{'production.capacity'|translate}} {{'ui.and'|translate|lowercase}} {{'production.occupancy-rate'|translate|lowercase}}</h4>
    <div class="float-end mt-1 clearfix">
      {{'project.orders'|translate}} {{'order.on-call'|translate|lowercase}}:
      <b>{{capacities.onCall.orderCount}}</b> (<b>{{capacities.onCall.amount|float:1}}</b> m<sup>3</sup>)
    </div>
  </div>
  <div *ngIf="capacities.plants.length; else noCapacities" class="table-responsive">
    <table class="table table-sm table-borderless capacity-chart">
      <thead>
        <tr>
          <td class="clock"><i class="far fa-clock"></i></td>
          <td *ngFor="let period of periodHeaders" class="period pb-1">
            {{formatPeriod(period)}}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let plantCapacity of capacities.plants; trackBy: trackByPlantId">
          <td class="plant ps-0">
            <b>{{plantCapacity.plant.name}}</b>
            <div class="plant-capacity">
              {{plantCapacity.productionCapacity|float:0}} m<sup>3</sup>/u
            </div>
          </td>
          <td *ngFor="let period of plantCapacity.periods" class="period">
            <div class="capacity-bar-value">{{period.loadPercentage}}%</div>
            <div class="capacity-bar-track" [attr.aria-label]="period.loadPercentage + '% bezetting'">
              <div
                class="capacity-bar"
                [ngClass]="'bg-'+getLoadType(period.loadPercentage)"
                [style.height.%]="getBarHeight(period.loadPercentage)">
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="capacities.plants.length" class="legend clearfix mt-3 mb-2">
    <div class="float-end ms-3">
      <div class="dot float-start me-1 bg-danger">&nbsp;</div>
      <div class="float-start">{{'ui.overloaded'|translate}}</div>
    </div>
    <div class="float-end ms-3">
      <div class="dot float-start me-1 bg-warning">&nbsp;</div>
      <div class="float-start">{{'ui.high-adjective'|translate}} {{'production.occupancy'|translate|lowercase}}</div>
    </div>
    <div class="float-end">
      <div class="dot float-start me-1 bg-success">&nbsp;</div>
      <div class="float-start">{{'ui.available'|translate}}</div>
    </div>
  </div>

  <ng-template #noCapacities>
    <jbm-empty-view [emptyView]="true"></jbm-empty-view>
  </ng-template>
</div>
